import { render, staticRenderFns } from "./ShowSectionQuestion.vue?vue&type=template&id=4347f2e8"
import script from "./ShowSectionQuestion.vue?vue&type=script&lang=js"
export * from "./ShowSectionQuestion.vue?vue&type=script&lang=js"
import style0 from "./ShowSectionQuestion.vue?vue&type=style&index=0&id=4347f2e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports